import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
// import { IoChevronBackCircleOutline } from "react-icons/io5";
import instance, { lienImage } from "../../api/api";
// import Badge from "react-bootstrap/Badge";
// import Swal from "sweetalert2";
// import withReactContent from "sweetalert2-react-content";
// import Spinner from "react-bootstrap/Spinner";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
// import { DataTable } from "primereact/datatable";
// import { Column } from "primereact/column";
// import { TabView, TabPanel } from "primereact/tabview";
// import { NavLink } from "react-router-dom";
// import { AiFillEye } from "react-icons/ai";
// import { FilterMatchMode } from "primereact/api";
// import { InputText } from "primereact/inputtext";
// import { Button } from "primereact/button";
// import ButtonFeature from "../../features/Button"
// import { BiSolidUserDetail } from "react-icons/bi";
import {
  Header,
  LoadingSpinner,
  InfoDetails,
  ModalDelete,
} from "../../shared/compoments";
import "primeicons/primeicons.css";
import { GrGallery } from "react-icons/gr";
import { GoPencil, GoPerson } from "react-icons/go";

// import { handleSeeGalerieBiens } from "../../store/slice/GalerieContrat";
import { useDispatch } from "react-redux";
import { showModal } from "../../store/slice/PrintSlice";
import { Help } from "../../utils";
import { Galleria } from "primereact/galleria";

function DetailPropriete() {
  const navigate = useNavigate();
  const galleria = useRef(null);
  const { id } = useParams();
  const [detailPropriete, setDetailPropriete] = useState(null);
  const [detailInfo, setDetailInfo] = useState([]);
  const dispatch = useDispatch();
  // const seeGalerieBiens = useSelector(
  //   (state) => state.galerie.seeGalerieBiens
  // );

  const itemTemplate = (item) => {
    return (
      <img
        src={lienImage + item.path}
        alt={item.alt}
        style={{ width: "100%", display: "block" }}
      />
    );
  };

  const thumbnailTemplate = (item) => {
    return (
      <img
        src={item.thumbnailImageSrc}
        alt={item.alt}
        style={{ display: "block" }}
      />
    );
  };

  const dataInfoDetail = (
    nom,
    cost,
    adresse,
    municipality,
    type,
    nombre_pieces,
    nombre_portes,
    caution,
    description,
    statut,
    declaration_des_impots,
    created_at
  ) => {
    console.log("declaration_des_impots", declaration_des_impots);
    const element = [];
    element.push(
      { title: "STATUT", value: statut },
      { title: "DATE DE MISE EN LIGNE", value: Help.convertDate(created_at) },
      { title: "BIEN", value: nom },
      { title: "PRIX (Fcfa)", value: `${Help.convertInMoney(cost)} Fcfa` },
      { title: "ADRESSE", value: adresse },
      { title: "COMMUNE", value: municipality.name },
      { title: "CATEGORIE DE BIEN", value: type.category.label },
      { title: "NOMBRE DE PIECE", value: nombre_pieces },
      { title: "NOMBRE DE PORTES", value: nombre_portes },
      { title: "DÉCLARATION IMPOT", value: declaration_des_impots },
      { title: "CAUTION", value: caution },
      { title: "DESCRIPTION", value: description }
    );
    setDetailInfo(element);
    console.log("detailInfo85", detailInfo);
  };

  useEffect(() => {
    const getDetailPropriete = async () => {
      try {
        const response = await instance.get(`proprieties/${id}`);
        console.log("getDetailPropriete25", response.data.data);
        const {
          nom,
          cost,
          adresse,
          municipality,
          type,
          nombre_pieces,
          nombre_portes,
          caution,
          description,
          statut,
          declaration_des_impots,
          created_at,
        } = response.data.data;
        dataInfoDetail(
          nom,
          cost,
          adresse,
          municipality,
          type,
          nombre_pieces,
          nombre_portes,
          caution,
          description,
          statut,
          declaration_des_impots,
          created_at
        );
        setDetailPropriete(response.data.data);
      } catch (error) {
        console.error("Une erreur s'est produite : ", error);
      }
    };
    getDetailPropriete();
  }, [id]);

  const DATA_BTN_WITH_CONTRAT_OPTIONS = [
    {
      titleBtn: "Voir les images",
      icone: <GrGallery />,
      isColor: false,
      isVisible: detailPropriete?.photos.length > 0 ? true : false,
      methode: () => {
        // dispatch(handleSeeGalerieBiens());
        galleria.current.show();
      },
    },
    {
      titleBtn: "Modifier le bien",
      icone: <GoPencil />,
      isColor: false,
      isVisible: true,
      methode: () => {
        navigate(`/editer/biens/${id}`);
      },
    },
    {
      titleBtn: "Voir les locataires",
      icone: <GoPerson />,
      isColor: false,
      isVisible:
        detailPropriete?.contracts.length > 0 &&
        detailPropriete?.type_de_transaction === "EN LOCATION"
          ? true
          : false,
      methode: () => {
        dispatch(showModal());
        // navigate(`/editer/biens/${id}`);
      },
    },
    {
      titleBtn: "Client",
      icone: <GoPerson />,
      isColor: false,
      isVisible:
        detailPropriete?.contracts.length > 0 &&
        detailPropriete?.type_de_transaction === "EN VENTE"
          ? true
          : false,
      methode: () => {
        dispatch(showModal());
      },
    },
  ];

  return (
    <>
      {
        <Galleria
          ref={galleria}
          value={detailPropriete?.photos}
          numVisible={9}
          style={{ maxWidth: "50%" }}
          circular
          fullScreen
          showItemNavigators
          showThumbnails={false}
          item={itemTemplate}
          thumbnail={thumbnailTemplate}
        />
      }
      {detailPropriete != null ? (
        <div>
          <ModalDelete
            locataireInHouse
            infoForLocataireInHouse={detailPropriete?.contracts}
            modalTitle={"Clients"}
            isPrintFacture={false}
            isRejectedBtn={false}
            dataInfoForBtn={[]}
          />
          <Header libelle={"Détails bien"} isReturn />

          <InfoDetails
            namePerson={`${detailPropriete.proprietaire.nom} ${detailPropriete.proprietaire.prenom}`}
            detailPhone={detailPropriete.proprietaire.phone}
            detailAdresse={detailPropriete.proprietaire.adresse}
            detailEmail={detailPropriete.proprietaire.email}
            titleInfo={"Détails du bien"}
            widthBody={"41%"}
            dataInfo={detailInfo}
            dataBtnWithOptions={
              detailPropriete?.photos.length > 0
                ? DATA_BTN_WITH_CONTRAT_OPTIONS
                : []
            }
          />
        </div>
      ) : (
        <div
          style={{
            textAlign: "center",
          }}>
          <LoadingSpinner />
        </div>
      )}
    </>
  );
}

export default DetailPropriete;
